import { APP_CONFIG_URL } from 'services/constants';

export const getAppConfig = async () => {
  const response = await fetch(APP_CONFIG_URL);

  if (!response.ok) {
    throw new Error(`HTTP error! Status: ${response.status}`);
  }

  // Mirror axios' lenient parsing: return JSON when the body is JSON,
  // otherwise return the raw text without throwing.
  const text = await response.text();
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};
